/**
 * Cart Drawer 2 - 完全独立的购物车弹窗组件
 * 不依赖任何外部函数或对象，可在任何 Shopify 模板中使用
 */

// ============================================
// Header cart count 同步（mt custom header）
// ============================================
function mtUpdateHeaderCartCount(itemCount) {
  const count = Number(itemCount) || 0;
  const displayText = count > 99 ? '99+' : String(count);

  document.querySelectorAll('.mt-mega-header__cart-count[data-cart-count]').forEach((el) => {
    if (count <= 0) {
      el.textContent = '';
      el.style.display = 'none';
      el.setAttribute('aria-hidden', 'true');
      return;
    }

    el.textContent = displayText;
    el.style.display = '';
    el.setAttribute('aria-hidden', 'false');
  });
}

// ============================================
// 数量选择器组件
// ============================================
class MtQuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('.mt-quantity-input__input');
    this.minusButton = this.querySelector('.mt-quantity-input__button--minus');
    this.plusButton = this.querySelector('.mt-quantity-input__button--plus');
    
    if (!this.input) return;

    this.min = parseInt(this.input.min) || 0;
    this.max = parseInt(this.input.max) || Infinity;
    this.step = parseInt(this.input.step) || 1;

    this.minusButton.addEventListener('click', this.decrease.bind(this));
    this.plusButton.addEventListener('click', this.increase.bind(this));
    this.input.addEventListener('change', this.onChange.bind(this));
    this.input.addEventListener('blur', this.validate.bind(this));

    this.updateButtons();
  }

  decrease() {
    const currentValue = parseInt(this.input.value) || 0;
    const newValue = Math.max(this.min, currentValue - this.step);
    if (newValue !== currentValue) {
      this.input.value = newValue;
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
      this.updateButtons();
    }
  }

  increase() {
    const currentValue = parseInt(this.input.value) || 0;
    const newValue = Math.min(this.max, currentValue + this.step);
    if (newValue !== currentValue) {
      this.input.value = newValue;
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
      this.updateButtons();
    }
  }

  onChange() {
    this.validate();
    this.updateButtons();
  }

  validate() {
    let value = parseInt(this.input.value) || 0;
    if (value < this.min) value = this.min;
    if (value > this.max) value = this.max;
    if (value !== parseInt(this.input.value)) {
      this.input.value = value;
    }
  }

  updateButtons() {
    const value = parseInt(this.input.value) || 0;
    if (this.minusButton) {
      this.minusButton.disabled = value <= this.min;
    }
    if (this.plusButton) {
      this.plusButton.disabled = value >= this.max;
    }
  }
}

customElements.define('mt-quantity-input', MtQuantityInput);

// ============================================
// 删除按钮组件
// ============================================
class MtCartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('.mt-cart-remove-button__btn');
    if (this.button) {
      this.button.addEventListener('click', this.handleClick.bind(this));
    }
  }

  handleClick(event) {
    event.preventDefault();
    const index = this.dataset.index;
    const cartItems = this.closest('cart-drawer-items2');
    if (cartItems) {
      cartItems.updateQuantity(index, 0);
    }
  }
}

customElements.define('mt-cart-remove-button', MtCartRemoveButton);

// ============================================
// Cart Note 组件
// ============================================
class MtCartNote extends HTMLElement {
  constructor() {
    super();
    this.textarea = this.querySelector('textarea');
    if (!this.textarea) return;

    let timeout;
    this.textarea.addEventListener('input', () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        this.saveNote();
      }, 500);
    });
  }

  saveNote() {
    const note = this.textarea.value;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ note }),
    }).catch((error) => {
    });
  }
}

customElements.define('mt-cart-note', MtCartNote);

// ============================================
// Cart Drawer Items 2 - 处理购物车更新
// ============================================
class CartDrawerItems2 extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', (event) => {
      if (event.target.classList.contains('mt-quantity-input__input')) {
        const index = event.target.dataset.index;
        const quantity = parseInt(event.target.value) || 0;
        this.updateQuantity(index, quantity);
      }
    });
  }

  updateQuantity(line, quantity) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: 'cart-drawer2',
      sections_url: window.location.pathname,
    });

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body,
    })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);
        
        if (parsedState.errors) {
          this.showError(line, parsedState.errors);
          this.disableLoading(line);
          return;
        }

        if (parsedState.item_count === 0 || 
            quantity === 0 || 
            !parsedState.sections || 
            !parsedState.sections['cart-drawer2']) {
          this.refreshCartContents();
        } else {
          this.updateCartContents(parsedState);
        }
        
        this.updateCartIcon(parsedState);
      })
      .catch((error) => {
        console.error('Cart update error:', error);
        this.showError(line, 'An error occurred while updating the cart.');
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateCartContents(parsedState) {
    let sectionHtml = null;
    let sectionKey = null;
    
    if (parsedState.sections) {
      sectionKey = Object.keys(parsedState.sections).find(key => 
        key === 'cart-drawer2' || 
        key === 'cart-drawer' ||
        key.includes('cart-drawer2') || 
        key.includes('cart-drawer')
      );
      if (sectionKey) {
        const sectionValue = parsedState.sections[sectionKey];
        if (typeof sectionValue === 'string') {
          sectionHtml = sectionValue;
        } else if (typeof sectionValue === 'object' && sectionValue) {
          sectionHtml = sectionValue.html || sectionValue.content || null;
        }
      }
    }

    if (sectionHtml && typeof sectionHtml === 'string' && sectionHtml.trim().length > 0) {
      const html = new DOMParser().parseFromString(sectionHtml, 'text/html');
      const sourceDrawer2 = html.querySelector('cart-drawer2');
      const sourceDrawer = sourceDrawer2?.querySelector('cart-drawer-items2') || html.querySelector('cart-drawer-items2');
      
      if (sourceDrawer) {
        // 只更新 form 内的商品列表
        const targetItems = document.getElementById('CartDrawer2-CartItems');
        if (targetItems) {
          const sourceItems = sourceDrawer.querySelector('.mt-drawer2__contents') || sourceDrawer.querySelector('#CartDrawer2-CartItems');
          if (sourceItems) {
            targetItems.innerHTML = sourceItems.innerHTML;
          }
        }
        
        // 更新 footer 部分（包含折扣提示区域）
        if (sourceDrawer2) {
          const drawer2 = document.querySelector('cart-drawer2');
          if (drawer2) {
            const targetFooter = drawer2.querySelector('.mt-drawer2__footer');
            const sourceFooter = sourceDrawer2.querySelector('.mt-drawer2__footer');
            if (targetFooter && sourceFooter) {
              const newFooter = sourceFooter.cloneNode(true);
              targetFooter.replaceWith(newFooter);
              
              // 更新折扣提示显示文本为最新的提示
              const discountError = newFooter.querySelector('.cart-drawer-discount-error');
              if (discountError) {
                const hasAppliedDiscount = !!newFooter.querySelector('.discounts__discount');
                const tips = discountError.getAttribute('data-tips') || '';
                const successTips = discountError.getAttribute('data-tips-success') || '';
                discountError.innerText = hasAppliedDiscount ? successTips : tips;
                discountError.classList.remove("mt-error")
              }
            }
          }
        }
      } else {
        this.refreshCartContents();
        return;
      }
    } else {
      this.refreshCartContents();
      return;
    }

    const drawer = document.querySelector('cart-drawer2');
    if (drawer) {
      if (!parsedState.items || !Array.isArray(parsedState.items) || parsedState.items.length === 0) {
        fetch('/cart.js')
          .then(response => response.json())
          .then(cartData => {
            drawer.updateTotalsFromState({ ...parsedState, ...cartData });
          })
          .catch(() => {
            drawer.updateTotalsFromState(parsedState);
          });
      } else {
        drawer.updateTotalsFromState(parsedState);
      }
      drawer.bindDiscountEvents();
    }

    this.updateEmptyState(parsedState);
  }

  updateEmptyState(parsedState) {
    const drawer2 = document.querySelector('cart-drawer2');
    const drawerItems2 = document.querySelector('cart-drawer-items2');
    const emptyState = document.getElementById('CartDrawer2-Empty');
    const cartForm = document.getElementById('CartDrawer2-Form');
    const footer = document.querySelector('.mt-drawer2__footer');
    
    const isEmpty = parsedState.item_count === 0;
    
    if (drawer2) {
      drawer2.classList.toggle('is-empty', isEmpty);
    }
    
    if (drawerItems2) {
      drawerItems2.classList.toggle('is-empty', isEmpty);
    }
    
    // 控制显示/隐藏
    if (emptyState) {
      emptyState.style.display = isEmpty ? '' : 'none';
    }
    
    if (cartForm) {
      cartForm.style.display = isEmpty ? 'none' : '';
    }
    
    if (footer) {
      footer.style.display = isEmpty ? 'none' : '';
    }
    
    const checkoutButton = document.getElementById('CartDrawer2-Checkout');
    if (checkoutButton) {
      checkoutButton.disabled = isEmpty;
    }
  }

  updateCartIcon(parsedState) {
    const cartIcon = document.getElementById('cart-icon-bubble');
    if (cartIcon) {
      const countElement = cartIcon.querySelector('.cart-count-bubble');
      if (countElement) {
        countElement.textContent = parsedState.item_count || 0;
      }
    }
    mtUpdateHeaderCartCount(parsedState?.item_count);
  }

  enableLoading(line) {
    const item = document.getElementById(`CartDrawer2-Item-${line}`);
    if (item) {
      const loading = item.querySelector('.mt-cart-drawer2-item__loading');
      if (loading) {
        loading.classList.remove('hidden');
      }
      item.closest('form')?.classList.add('cart__items--disabled');
    }
  }

  disableLoading(line) {
    const item = document.getElementById(`CartDrawer2-Item-${line}`);
    if (item) {
      const loading = item.querySelector('.mt-cart-drawer2-item__loading');
      if (loading) {
        loading.classList.add('hidden');
      }
      item.closest('form')?.classList.remove('cart__items--disabled');
    }
  }

  showError(line, errorMessage) {
    const errorElement = document.getElementById(`CartDrawer2-LineItemError-${line}`);
    if (errorElement) {
      const errorText = errorElement.querySelector('.mt-cart-drawer2-item__error-text');
      if (errorText) {
        errorText.textContent = typeof errorMessage === 'string' ? errorMessage : 'An error occurred';
        errorElement.classList.remove('hidden');
      }
    }
  }

  refreshCartContents() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cartData => {
        const cartUrl = (window.routes && window.routes.cart_url) || routes?.cart_url || '/cart';
        fetch(`${cartUrl}?section_id=cart-drawer2`)
          .then((response) => {
            if (!response.ok) {
              this.updateCartState(cartData);
              return null;
            }
            return response.text();
          })
          .then((responseText) => {
            if (!responseText) return;
            
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceDrawer2 = html.querySelector('cart-drawer2');
            const sourceDrawer = sourceDrawer2?.querySelector('cart-drawer-items2') || html.querySelector('cart-drawer-items2');
            
            if (sourceDrawer) {
              // 只更新 form 内的商品列表
              const targetItems = document.getElementById('CartDrawer2-CartItems');
              if (targetItems) {
                const sourceItems = sourceDrawer.querySelector('.mt-drawer2__contents');
                if (sourceItems) {
                  targetItems.innerHTML = sourceItems.innerHTML;
                }
              }
              
              // 更新 footer 部分（包含折扣提示区域）
              if (sourceDrawer2) {
                const drawer2 = document.querySelector('cart-drawer2');
                if (drawer2) {
                  const targetFooter = drawer2.querySelector('.mt-drawer2__footer');
                  const sourceFooter = sourceDrawer2.querySelector('.mt-drawer2__footer');
                  if (targetFooter && sourceFooter) {
                    const newFooter = sourceFooter.cloneNode(true);
                    targetFooter.replaceWith(newFooter);
                    
                    // 更新折扣提示显示文本为最新的提示
                    const discountError = newFooter.querySelector('.cart-drawer-discount-error');
                    if (discountError) {
                      const hasAppliedDiscount = !!newFooter.querySelector('.discounts__discount');
                      const tips = discountError.getAttribute('data-tips') || '';
                      const successTips = discountError.getAttribute('data-tips-success') || '';
                      discountError.innerText = hasAppliedDiscount ? successTips : tips;
                      discountError.classList.remove("mt-error")
                    }
                  }
                }
              }
            }
            
            this.updateCartState(cartData);
          })
          .catch((error) => {
            console.error('Failed to refresh cart contents:', error);
            this.updateCartState(cartData);
          });
      })
      .catch(error => {
        console.error('Failed to fetch cart data:', error);
      });
  }

  updateCartState(cartData) {
    const drawer = document.querySelector('cart-drawer2');
    if (!drawer) return;
    
    if (cartData && (cartData.items || cartData.total_price !== undefined)) {
      drawer.updateTotalsFromState(cartData);
    } else {
      fetch('/cart.js')
        .then(response => response.json())
        .then(fullCartData => {
          drawer.updateTotalsFromState(fullCartData);
        })
        .catch(error => {
          console.error('Failed to fetch cart data:', error);
        });
    }
    drawer.bindDiscountEvents();
    
    // 使用统一的显示/隐藏控制
    this.updateEmptyState(cartData);
    this.updateCartIcon(cartData);
  }
}

customElements.define('cart-drawer-items2', CartDrawerItems2);

// ============================================
// 焦点管理
// ============================================
function mtGetFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function mtTrapFocus(container, elementToFocus = container) {
  const elements = mtGetFocusableElements(container);
  const first = elements[0];
  const last = elements[elements.length - 1];

  mtRemoveTrapFocus();

  const focusinHandler = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', keydownHandler);
  };

  const focusoutHandler = function () {
    document.removeEventListener('keydown', keydownHandler);
  };

  const keydownHandler = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return;
    
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', focusoutHandler);
  document.addEventListener('focusin', focusinHandler);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }

  window._mtTrapFocusHandlers = {
    focusin: focusinHandler,
    focusout: focusoutHandler,
    keydown: keydownHandler,
  };
}

function mtRemoveTrapFocus(elementToFocus) {
  if (window._mtTrapFocusHandlers) {
    document.removeEventListener('focusout', window._mtTrapFocusHandlers.focusout);
    document.removeEventListener('focusin', window._mtTrapFocusHandlers.focusin);
    document.removeEventListener('keydown', window._mtTrapFocusHandlers.keydown);
    window._mtTrapFocusHandlers = null;
  }
  
  if (elementToFocus) {
    elementToFocus.focus();
  }
}

// ============================================
// Cart Drawer 2 - 主组件
// ============================================
class CartDrawer2 extends HTMLElement {
  constructor() {
    super();
    this.overlay = this.querySelector('#CartDrawer2-Overlay');
    this.activeElement = null;
    this.discountUiStorageKey = 'mt_cart_drawer2_discount_ui_enabled';

    this.addEventListener('keyup', (evt) => {
      if (evt.code === 'Escape') this.close();
    });

    if (this.overlay) {
      this.overlay.addEventListener('click', this.close.bind(this));
    }

    const closeBtn = this.querySelector('[data-cart-drawer2-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', this.close.bind(this));
    }

    this.setHeaderCartIconAccessibility();
    
    // 初始化时绑定折扣码事件（延迟执行，确保 DOM 已加载）
    setTimeout(() => {
      this.bindDiscountEvents();
      this.applyDiscountUiVisibility();
    }, 100);
  }

  setHeaderCartIconAccessibility() {
    const cartLink =
      document.querySelector('[data-cart-trigger="drawer2"]') ||
      document.querySelector('#cart-icon-bubble');

    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) {
      this.setActiveElement(triggeredBy);
    }

    const drawerInner = this.querySelector('.mt-drawer2__inner');
    if (!drawerInner) {
      console.warn('[Cart2] Drawer inner not found');
      return;
    }

    setTimeout(() => {
      this.classList.add('mt-drawer2--active');
      // 在打开后绑定折扣码事件
      setTimeout(() => {
        this.bindDiscountEvents();
        this.applyDiscountUiVisibility();
      }, 200);
    }, 10);

    this.addEventListener(
      'transitionend',
      () => {
        const focusElement = drawerInner.querySelector('[data-cart-drawer2-close]') || drawerInner;
        mtTrapFocus(drawerInner, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('mt-drawer2--active');

    if (this.activeElement) {
      mtRemoveTrapFocus(this.activeElement);
    }

    document.body.classList.remove('overflow-hidden');
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  getDiscountUiEnabled() {
    try {
      return localStorage.getItem(this.discountUiStorageKey) === '1';
    } catch (e) {
      return false;
    }
  }

  setDiscountUiEnabled(enabled) {
    try {
      localStorage.setItem(this.discountUiStorageKey, enabled ? '1' : '0');
    } catch (e) {
      // ignore
    }
  }

  applyDiscountUiVisibility() {
    const enabled = this.getDiscountUiEnabled();
    const discountRow = this.querySelector('[data-discount-row]');
    const appliedList = this.querySelector('[data-discount-applied]');
    const tips = this.querySelector('[data-discount-tips]');

    if (discountRow) discountRow.style.display = enabled ? '' : 'none';
    if (appliedList) appliedList.style.display = enabled ? '' : 'none';

    if (!enabled && tips) {
      tips.innerText = tips.getAttribute('data-tips') || tips.innerText;
      tips.classList.remove('mt-error');
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer2',
        section: 'cart-drawer2',
        selector: '#CartDrawer2',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
      },
    ];
  }

  renderContents(parsedState) {
    const drawerInner = this.querySelector('.mt-drawer2__inner');
    if (!drawerInner) return;

    this.classList.toggle('is-empty', parsedState.item_count === 0);

    if (!parsedState.sections || Object.keys(parsedState.sections).length === 0) {
      const cartUrl = (window.routes && window.routes.cart_url) || routes?.cart_url || '/cart';
      fetch(`${cartUrl}?section_id=cart-drawer2`)
        .then(r => r.ok ? r.text() : null)
        .then(sectionHtml => {
          if (sectionHtml) {
            const html = new DOMParser().parseFromString(sectionHtml, 'text/html');
            const sectionElement = html.querySelector('.shopify-section');
            if (sectionElement) {
              parsedState.sections = {
                'cart-drawer2': sectionElement.outerHTML
              };
              this.updateCartContent(parsedState);
            } else {
              this.open();
            }
          } else {
            this.open();
          }
        })
        .catch(() => {
          this.open();
        });
      return;
    }

    this.updateCartContent(parsedState);
  }

  updateCartContent(parsedState) {
    let cartDrawerHtml = null;
    
    if (parsedState.sections) {
      const cartDrawer2Value = parsedState.sections['cart-drawer2'];
      
      if (cartDrawer2Value) {
        if (typeof cartDrawer2Value === 'string') {
          cartDrawerHtml = cartDrawer2Value;
        } else if (typeof cartDrawer2Value === 'object' && cartDrawer2Value) {
          cartDrawerHtml = cartDrawer2Value.html || cartDrawer2Value.content || null;
        }
      }
      
      if (!cartDrawerHtml && parsedState.sections['cart-drawer']) {
        const cartDrawerValue = parsedState.sections['cart-drawer'];
        if (typeof cartDrawerValue === 'string') {
          cartDrawerHtml = cartDrawerValue;
        }
      }
      
      if (!cartDrawerHtml) {
        const matchingKey = Object.keys(parsedState.sections).find(key => 
          key.includes('cart-drawer2') || key.includes('cart-drawer')
        );
        if (matchingKey) {
          const matchingValue = parsedState.sections[matchingKey];
          if (typeof matchingValue === 'string') {
            cartDrawerHtml = matchingValue;
          }
        }
      }
    }
    
    if (cartDrawerHtml && typeof cartDrawerHtml === 'string' && cartDrawerHtml.trim().length > 0) {
      const doc = new DOMParser().parseFromString(cartDrawerHtml, 'text/html');
      const sourceDrawer2 = doc.querySelector('cart-drawer2');
      const sourceDrawerItems = sourceDrawer2?.querySelector('cart-drawer-items2') || doc.querySelector('cart-drawer-items2');
      
      // 只更新 form 内的商品列表
      if (sourceDrawerItems) {
        const targetItems = document.getElementById('CartDrawer2-CartItems');
        if (targetItems) {
          const sourceItems = sourceDrawerItems.querySelector('.mt-drawer2__contents') || sourceDrawerItems.querySelector('#CartDrawer2-CartItems');
          if (sourceItems) {
            targetItems.innerHTML = sourceItems.innerHTML;
            this.updateTotalsAfterContentChange(parsedState);
          }
        }
      } else {
        this.fallbackToSectionAPI(parsedState);
      }

      // 同步 footer（含折扣提示）
      if (sourceDrawer2) {
        const targetFooter = this.querySelector('.mt-drawer2__footer');
        const sourceFooter = sourceDrawer2.querySelector('.mt-drawer2__footer');
        if (targetFooter && sourceFooter) {
          const newFooter = sourceFooter.cloneNode(true);
          targetFooter.replaceWith(newFooter);

          // 确保折扣提示文本与最新提示一致
          const discountError = newFooter.querySelector('.cart-drawer-discount-error');
          if (discountError) {
            const hasAppliedDiscount = !!newFooter.querySelector('.discounts__discount');
            const tips = discountError.getAttribute('data-tips') || '';
            const successTips = discountError.getAttribute('data-tips-success') || '';
            discountError.innerText = hasAppliedDiscount ? successTips : tips;
            discountError.classList.remove('mt-error')
          }
        }
      }
    } else {
      this.fallbackToSectionAPI(parsedState);
    }
    
    if (parsedState.sections) {
      const iconBubbleHtml = parsedState.sections['cart-icon-bubble'];
      if (iconBubbleHtml) {
        const sectionElement = document.getElementById('cart-icon-bubble');
        if (sectionElement) {
          const parsedHtml = new DOMParser().parseFromString(iconBubbleHtml, 'text/html');
          const shopifySection = parsedHtml.querySelector('.shopify-section');
          if (shopifySection) {
            sectionElement.innerHTML = shopifySection.innerHTML;
          }
        }
      }
    }

    this.updateTotalsAfterContentChange(parsedState);

    // 使用统一的显示/隐藏控制
    const drawerItems2 = document.querySelector('cart-drawer-items2');
    if (drawerItems2 && typeof drawerItems2.updateEmptyState === 'function') {
      drawerItems2.updateEmptyState(parsedState);
    }

    this.updateCartIcon(parsedState);
    this.bindDiscountEvents();

    setTimeout(() => {
      if (this.overlay) {
        this.overlay.addEventListener('click', this.close.bind(this));
      }
      this.open();
    }, 100);
  }

  fallbackToSectionAPI(parsedState) {
    const drawerItems2 = document.querySelector('cart-drawer-items2');
    if (drawerItems2 && typeof drawerItems2.refreshCartContents === 'function') {
      drawerItems2.refreshCartContents();
    } else {
      const cartUrl = (window.routes && window.routes.cart_url) || routes?.cart_url || '/cart';
      fetch(`${cartUrl}?section_id=cart-drawer2`)
        .then(r => r.ok ? r.text() : null)
        .then(sectionHtml => {
          if (sectionHtml) {
            const html = new DOMParser().parseFromString(sectionHtml, 'text/html');
            const sourceDrawer = html.querySelector('cart-drawer-items2');
            if (sourceDrawer) {
              // 只更新 form 内的商品列表
              const targetItems = document.getElementById('CartDrawer2-CartItems');
              if (targetItems) {
                const sourceItems = sourceDrawer.querySelector('.mt-drawer2__contents') || sourceDrawer.querySelector('#CartDrawer2-CartItems');
                if (sourceItems) {
                  targetItems.innerHTML = sourceItems.innerHTML;
                }
              }
              this.updateCartStateAfterContentUpdate(parsedState);
            }
          }
        })
        .catch(error => {
          console.error('Failed to fetch section API:', error);
        });
    }
  }

  updateTotalsAfterContentChange(parsedState) {
    if (!parsedState.items || !Array.isArray(parsedState.items) || parsedState.items.length === 0) {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cartData => {
          this.updateTotalsFromState({ ...parsedState, ...cartData });
        })
        .catch(() => {
          this.updateTotalsFromState(parsedState);
        });
    } else {
      this.updateTotalsFromState(parsedState);
    }
  }

  updateCartStateAfterContentUpdate(parsedState) {
    this.updateTotalsAfterContentChange(parsedState);

    // 使用统一的显示/隐藏控制
    const drawerItems2 = document.querySelector('cart-drawer-items2');
    if (drawerItems2 && typeof drawerItems2.updateEmptyState === 'function') {
      drawerItems2.updateEmptyState(parsedState);
    }

    this.updateCartIcon(parsedState);
    this.bindDiscountEvents();
  }

  async setDiscount(event) {
    
    const discountBtn = event.target.closest('.discountcode-btn') || event.target;
    
    const discountContainer = this.querySelector('.cart-drawer-discount-container');

    // 仅在折扣模块上方添加加载遮罩，不影响商品列表
    const discountWrapper = this.querySelector('.mt-cart-drawer2__discount');
    let loadingOverlay = discountWrapper?.querySelector('.mt-discount-loading');
    if (!loadingOverlay && discountWrapper) {
      loadingOverlay = document.createElement('div');
      loadingOverlay.className = 'mt-discount-loading hidden';
      loadingOverlay.innerHTML = `
        <svg aria-hidden="true" focusable="false" class="mt-spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
          <circle class="mt-spinner__path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
        </svg>
      `;
      if (!getComputedStyle(discountWrapper).position || getComputedStyle(discountWrapper).position === 'static') {
        discountWrapper.style.position = 'relative';
      }
      discountWrapper.appendChild(loadingOverlay);
    }
    
    const loader = discountBtn?.querySelector('.loader-button__loader');
    const loaderText = discountBtn?.querySelector('.loader-button__text');
    
    if (loader) {
      loader.removeAttribute('hidden');
    }
    if (loaderText) {
      loaderText.style.display = 'none';
    }
    if (loadingOverlay) {
      loadingOverlay.classList.remove('hidden');
    }
    
    const response = await fetch('/cart.js');
    let cartToken = '';
    if (response.ok) {
      const responseJson = await response.json();
      if (responseJson.cart_level_discount_applications && responseJson.cart_level_discount_applications.length > 0) {
        this.discountFisrtCode = responseJson.cart_level_discount_applications[0].title || '';
      } else if (responseJson.items && responseJson.items.length > 0 && responseJson.items[0].discounts && responseJson.items[0].discounts.length > 0) {
        this.discountFisrtCode = responseJson.items[0].discounts[0].title || '';
      }
      cartToken = responseJson.token;
    } else {
      console.error('[Cart2] Failed to fetch cart data:', response.status);
    }
    
    const discountInput = this.querySelector('input[name=discount]');
    if (!discountInput) {
      console.error('[Cart2] Discount input not found!');
      if (loader) loader.setAttribute('hidden', '');
      if (loaderText) loaderText.style.display = '';
      if (loadingOverlay) loadingOverlay.classList.add('hidden');
      return;
    }

    const isDiscountItemClick = event.target.classList.contains('discounts__discount');
    const inputValue = discountInput.value.trim();

    // 如果是点 Apply 按钮，并且输入框为空，则不发请求，直接还原状态
    if (!isDiscountItemClick && !inputValue) {
      if (loader) loader.setAttribute('hidden', '');
      if (loaderText) loaderText.style.display = '';
      if (loadingOverlay) loadingOverlay.classList.add('hidden');
      return;
    }
    
    const discountCode = isDiscountItemClick ? '' : inputValue;

    if (!cartToken) {
      console.error('[Cart2] Cart token is empty!');
      if (loader) loader.setAttribute('hidden', '');
      if (loaderText) loaderText.style.display = '';
      if (loadingOverlay) loadingOverlay.classList.add('hidden');
      return;
    }

    const accessToken = window.mtStorefrontAccessToken || '63da65c0ec620d1a46f38cd204c00d9e';
    const cartId = `gid://shopify/Cart/${cartToken}`;
    const query = `
      mutation {
        cartDiscountCodesUpdate(
          cartId: "${cartId}",
          discountCodes: ${discountCode ? `["${discountCode}"]` : '[]'}
        ) {
          cart {
            id
            discountCodes {
              code
              applicable
            }
            checkoutUrl
          }
          userErrors {
            field
            message
          }
        }
      }`;

    const tips = this.querySelector('.cart-drawer-discount-error');

    fetch(`${window.location.origin}/api/2023-04/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': accessToken,
      },
      body: JSON.stringify({ query }),
    })
      .then(response => response.json())
      .then(data => {
        const isDiscountItem = event.target.classList.contains('discounts__discount');
        const userErrors = data?.data?.cartDiscountCodesUpdate?.userErrors || [];
        const firstDiscount = data?.data?.cartDiscountCodesUpdate?.cart?.discountCodes?.[0];
        const isApplicable = !!firstDiscount?.applicable;
        const isEmptyCode = firstDiscount?.code === '';

        if (userErrors.length) {
          if (tips) {
            tips.innerText = tips.getAttribute('data-tips-error');
            tips.classList.add('mt-error');
          }
          setTimeout(() => {
            if (loader) loader.setAttribute('hidden', '');
            if (loaderText) loaderText.style.display = '';
            if (loadingOverlay) loadingOverlay.classList.add('hidden');
          }, 2000);
          return;
        }

        if (isDiscountItem || isApplicable) {
          // Show success message immediately (no need to click X to refresh UI)
          if (tips) {
            tips.innerText = tips.getAttribute('data-tips-success') || '';
            tips.classList.remove('mt-error');
          }
          if (!isDiscountItem) this.setDiscountUiEnabled(true);
          this.updateCartDrawer2();
        } else if (isEmptyCode) {
          this.setDiscountUiEnabled(false);
          this.updateCartDrawer2(true);
        } else {
          if (tips) {
            tips.innerText = tips.getAttribute('data-tips-error');
            tips.classList.add('mt-error');
          }
        }
        setTimeout(() => {
          if (loader) loader.setAttribute('hidden', '');
          if (loaderText) loaderText.style.display = '';
          if (loadingOverlay) loadingOverlay.classList.add('hidden');
        }, 2000);
      })
      .catch(error => {
        console.error('[Cart2] GraphQL request error:', error);
        if (tips) {
          tips.innerText = tips.getAttribute('data-tips-error');
          tips.classList.add('mt-error');
        }
        setTimeout(() => {
          if (loader) loader.setAttribute('hidden', '');
          if (loaderText) loaderText.style.display = '';
          if (loadingOverlay) loadingOverlay.classList.add('hidden');
        }, 2000);
      });
  }

  updateCartDrawer2(removeCode) {
    const cartUrl = (window.routes && window.routes.cart_url) || routes?.cart_url || '/cart';
    
    fetch(`${cartUrl}?section_id=cart-drawer2`)
      .then((response) => {
        return response.text();
      })
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceDrawer = html.querySelector('cart-drawer2');
        
        if (sourceDrawer && document.querySelector('cart-drawer2')) {
          const drawer2 = document.querySelector('cart-drawer2');
          const sourceItems = sourceDrawer.querySelector('cart-drawer-items2');
          const footer = drawer2.querySelector('.mt-drawer2__footer');
   
          // 只更新 form 内的商品列表
          if (sourceItems) {
            const targetItems = document.getElementById('CartDrawer2-CartItems');
            if (targetItems) {
              const sourceCartItems = sourceItems.querySelector('.mt-drawer2__contents') || sourceItems.querySelector('#CartDrawer2-CartItems');
              if (sourceCartItems) {
                targetItems.innerHTML = sourceCartItems.innerHTML;
              }
            }
          }
          
          // 更新 footer
          if (footer) {
            const sourceFooter = sourceDrawer.querySelector('.mt-drawer2__footer');
            if (sourceFooter) {
              const newFooter = sourceFooter.cloneNode(true);
              footer.replaceWith(newFooter);
            }
          }
          
          this.bindDiscountEvents();
          this.applyDiscountUiVisibility();
          
          // 更新购物车状态（包括显示/隐藏控制）
          fetch('/cart.js')
            .then(response => response.json())
            .then(cartData => {
              const drawerItems2 = document.querySelector('cart-drawer-items2');
              if (drawerItems2 && typeof drawerItems2.updateEmptyState === 'function') {
                drawerItems2.updateEmptyState(cartData);
              }
            })
            .catch(error => {
              console.error('Failed to fetch cart data:', error);
            });
          
          // 从更新后的元素中获取提示信息
          const tipsAfter = this.querySelector('.cart-drawer-discount-error');
          if (tipsAfter) {
            if (removeCode) {
              // 移除折扣码时，显示普通提示
              const tips = tipsAfter.getAttribute('data-tips') || '';
              tipsAfter.innerText = tips;
              tipsAfter.classList.remove("mt-error")
              this.setDiscountUiEnabled(false);

            } else {
              // 成功应用折扣码时，显示成功提示
              // 成功应用折扣码时，显示 successTips（HOME10 有文案，HOME15 为空则不显示）
              tipsAfter.innerText = tipsAfter.getAttribute('data-tips-success') || '';
              tipsAfter.classList.remove("mt-error")
              this.setDiscountUiEnabled(true);
            }
          }
        } else {
          console.warn('[Cart2] Source drawer or target drawer not found');
        }
      })
      .catch((e) => {
        console.error('[Cart2] updateCartDrawer2 error:', e);
        const tipsAfter = this.querySelector('.cart-drawer-discount-error');
        if (tipsAfter) {
          tipsAfter.innerText = tipsAfter.getAttribute('data-tips-error');
          tipsAfter.classList.add("mt-error")
        }
      });
  }

  bindDiscountEvents() {
    
    const discountBtn = this.querySelector('.discountcode-btn');

    
    if (discountBtn) {
      // 先移除所有现有的事件监听器
      const newBtn = discountBtn.cloneNode(true);
      if (discountBtn.parentNode) {
        discountBtn.parentNode.replaceChild(newBtn, discountBtn);
      }
      
      // 绑定新的事件监听器
      newBtn.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.setDiscount(event);
      });
    } 

    const discountItems = this.querySelectorAll('.discounts__discount');
    discountItems.forEach((item, index) => {
      const newItem = item.cloneNode(true);
      if (item.parentNode) {
        item.parentNode.replaceChild(newItem, item);
      }
      
      newItem.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.setDiscount(event);
      });
    });
  }

  updateTotalsFromState(parsedState) {
    const totalsRows = this.querySelectorAll('.mt-cart-drawer2__totals-row');
    if (totalsRows.length >= 4) {
      let subtotal = 0;
      if (parsedState.items && Array.isArray(parsedState.items) && parsedState.items.length > 0) {
        subtotal = parsedState.items.reduce((sum, item) => {
          return sum + (item.original_line_price || item.line_price || 0);
        }, 0);
      } else {
        const totalPrice = parsedState.total_price || 0;
        const totalDiscount = parsedState.total_discount || 0;
        subtotal = totalPrice + totalDiscount;
      }
      
      const subtotalValue = totalsRows[0].querySelector('.mt-cart-drawer2__totals-value');
      if (subtotalValue) {
        this.ensureTotalsValuePrefixSuffix(subtotalValue);
        const prefix = subtotalValue.dataset.prefix || '';
        const suffix = subtotalValue.dataset.suffix || '';
        const amountStr = this.formatMoneyAmountOnly(subtotal, parsedState.currency || window.Shopify?.currency?.active || 'USD');
        subtotalValue.textContent = `${prefix}${amountStr}${suffix}`;
      }

      const discount = parsedState.total_discount || 0;
      const discountValue = totalsRows[1].querySelector('.mt-cart-drawer2__totals-value');
      if (discountValue) {
        this.ensureTotalsValuePrefixSuffix(discountValue);
        const prefix = (discountValue.dataset.prefix || '').replace(/^-/, '');
        const suffix = discountValue.dataset.suffix || '';
        const amountStr = this.formatMoneyAmountOnly(discount, parsedState.currency || window.Shopify?.currency?.active || 'USD');
        const sign = discount > 0 ? '-' : '';
        discountValue.textContent = `${prefix}${sign}${amountStr}${suffix}`;
      }

      const total = parsedState.total_price || 0;
      const totalValue = totalsRows[3].querySelector('.mt-cart-drawer2__totals-value');
      if (totalValue) {
        this.ensureTotalsValuePrefixSuffix(totalValue);
        const prefix = totalValue.dataset.prefix || '';
        const suffix = totalValue.dataset.suffix || '';
        const amountStr = this.formatMoneyAmountOnly(total, parsedState.currency || window.Shopify?.currency?.active || 'USD');
        totalValue.textContent = `${prefix}${amountStr}${suffix}`;
      }
    }
  }

  ensureTotalsValuePrefixSuffix(valueElement) {
    if (!valueElement || valueElement.dataset.prefixInitialized === 'true') return;
    const original = (valueElement.textContent || '').trim();
    // 拆分出：前缀（货币符号等） + 数字部分 + 后缀（货币代码等）
    const match = original.match(/^(\D*)([\d.,\-]+)(.*)$/);
    if (match) {
      valueElement.dataset.prefix = match[1] || '';
      valueElement.dataset.suffix = match[3] || '';
    } else {
      valueElement.dataset.prefix = '';
      valueElement.dataset.suffix = '';
    }
    valueElement.dataset.prefixInitialized = 'true';
  }

  formatMoneyAmountOnly(cents, currency) {
    const number = cents / 100;
    try {
      // 尽量使用本地数字格式（千分位、小数点），只返回纯数字
      return number.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    } catch (e) {
      const amount = number.toFixed(2);
      const parts = amount.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    }
  }

  formatMoney(cents, currency) {
    const amount = (cents / 100).toFixed(2);
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.money_format || '{{amount}}');
    }
    return `${currency} ${amount}`;
  }

  updateCartIcon(parsedState) {
    const cartIcon = document.getElementById('cart-icon-bubble');
    if (cartIcon) {
      const countElement = cartIcon.querySelector('.cart-count-bubble');
      if (countElement) {
        countElement.textContent = parsedState.item_count || 0;
      }
    }
    mtUpdateHeaderCartCount(parsedState?.item_count);
  }
}

customElements.define('cart-drawer2', CartDrawer2);

// ============================================
// 监听添加购物车事件，自动打开 cart-drawer2
// ============================================
(function() {
  const drawer2 = document.querySelector('cart-drawer2');
  if (!drawer2) return;

  if (window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
    document.addEventListener(window.PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.detail && event.detail.cartData && event.detail.source !== 'cart-drawer-items2') {
        drawer2.renderContents(event.detail.cartData);
      }
    });
  }

  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const url = args[0];
    const options = args[1] || {};
    
    if (typeof url === 'string' && (url.includes('/cart/add.js') || url.includes('/cart/add'))) {
      document.querySelectorAll('product-form').forEach((form) => {
        if (!form.cart || form.cart.tagName !== 'CART-DRAWER2') {
          const foundDrawer2 = document.querySelector('cart-drawer2');
          if (foundDrawer2) {
            form.cart = foundDrawer2;
          }
        }
      });
      
      const hasSections = options.body instanceof FormData 
        ? options.body.has('sections')
        : (options.body && options.body.includes && options.body.includes('sections'));
      
      if (!hasSections) {
        const modifiedOptions = { ...options };
        
        if (options.body instanceof FormData) {
          const newFormData = new FormData();
          for (const [key, value] of options.body.entries()) {
            newFormData.append(key, value);
          }
          newFormData.append('sections', 'cart-drawer2,cart-icon-bubble');
          newFormData.append('sections_url', window.location.pathname);
          modifiedOptions.body = newFormData;
        } else if (options.body) {
          try {
            const formData = new FormData();
            if (typeof options.body === 'string') {
              const params = new URLSearchParams(options.body);
              for (const [key, value] of params.entries()) {
                formData.append(key, value);
              }
            }
            formData.append('sections', 'cart-drawer2,cart-icon-bubble');
            formData.append('sections_url', window.location.pathname);
            modifiedOptions.body = formData;
          } catch (e) {
            // 忽略错误，继续使用原始请求
          }
        }
        
        return originalFetch.apply(this, [url, modifiedOptions])
          .then((response) => {
            if (response.ok) {
              return response.json().then((data) => {
                if (!data.status && !data.errors) {
                  // 检查是否是批量添加的一部分（tying-products）
                  const batchAddHeader = options.headers && (
                    options.headers['X-Batch-Add'] || 
                    options.headers.get && options.headers.get('X-Batch-Add')
                  );
                  const isBatchAdd = batchAddHeader === 'tying-products' || 
                                     batchAddHeader === 'main-product' || 
                                     window.__addingTyingProducts === true;
                  
                  // 如果是批量添加的一部分，且不是主产品（最后一步），则不自动打开购物车弹窗
                  if (batchAddHeader === 'tying-products') {
                    // 不自动打开，等待所有商品添加完成
                    return new Response(JSON.stringify(data), {
                      status: response.status,
                      statusText: response.statusText,
                      headers: {
                        'Content-Type': 'application/json',
                      },
                    });
                  }
                  
                  setTimeout(() => {
                    Promise.all([
                      fetch('/cart.js').then(r => r.json()).catch(() => null),
                      Promise.resolve(data.sections || null)
                    ]).then(([cartData, sections]) => {
                      if (!cartData) {
                        if (data.sections) {
                          // 如果是批量添加的主产品，不自动打开，由 product-form.js 控制
                          if (batchAddHeader !== 'main-product') {
                            drawer2.renderContents(data);
                          }
                        }
                        return;
                      }
                      
                      const mergedData = {
                        ...cartData,
                        sections: sections || data.sections || {}
                      };
                      
                      if (!mergedData.sections || Object.keys(mergedData.sections).length === 0) {
                        const cartUrl = (window.routes && window.routes.cart_url) || routes?.cart_url || '/cart';
                        return fetch(`${cartUrl}?section_id=cart-drawer2`)
                          .then(r => r.ok ? r.text() : null)
                          .then(sectionHtml => {
                            if (sectionHtml) {
                              const html = new DOMParser().parseFromString(sectionHtml, 'text/html');
                              const sectionElement = html.querySelector('.shopify-section');
                              if (sectionElement) {
                                mergedData.sections = {
                                  'cart-drawer2': sectionElement.outerHTML
                                };
                              }
                            }
                            // 如果是批量添加的主产品，不自动打开，由 product-form.js 控制
                            if (batchAddHeader !== 'main-product') {
                              drawer2.renderContents(mergedData);
                            }
                          })
                          .catch(() => {
                            if (batchAddHeader !== 'main-product') {
                              drawer2.renderContents(mergedData);
                            }
                          });
                      } else {
                        // 如果是批量添加的主产品，不自动打开，由 product-form.js 控制
                        if (batchAddHeader !== 'main-product') {
                          drawer2.renderContents(mergedData);
                        }
                      }
                    }).catch(() => {
                      if (data.sections) {
                        if (batchAddHeader !== 'main-product') {
                          drawer2.renderContents(data);
                        }
                      }
                    });
                  }, 100);
                }
                
                return new Response(JSON.stringify(data), {
                  status: response.status,
                  statusText: response.statusText,
                  headers: {
                    'Content-Type': 'application/json',
                  },
                });
              });
            }
            return response;
          });
      } else {
        return originalFetch.apply(this, args)
          .then((response) => {
            if (response.ok) {
              const clonedResponse = response.clone();
              clonedResponse.json().then((data) => {
                if (!data.status && !data.errors) {
                  setTimeout(() => {
                    fetch('/cart.js')
                      .then(r => r.json())
                      .then(cartData => {
                        const mergedData = {
                          ...cartData,
                          sections: data.sections || {}
                        };
                        drawer2.renderContents(mergedData);
                      })
                      .catch(() => {
                        if (data.sections) {
                          drawer2.renderContents(data);
                        }
                      });
                  }, 100);
                }
              }).catch(() => {});
            }
            return response;
          });
      }
    }
    
    return originalFetch.apply(this, args);
  };

  document.addEventListener('cart:add', (event) => {
    if (event.detail && event.detail.cartData) {
      drawer2.renderContents(event.detail.cartData);
    }
  });
})();


// 供 mt-custom-header 等调用的全局方法：点击购物车按钮时打开购物车，为 .mt-drawer2 添加 mt-drawer2--active
window.openCartDrawer = function() {
  const drawer = document.querySelector('.mt-drawer2');
  if (!drawer) return;
  if (typeof drawer.open === 'function') {
    drawer.open();
  } else {
    drawer.classList.add('mt-drawer2--active');
  }
};
